import React from 'react'
import ChooseTipoDePagamentoDialog from './chooseTipoDePagamentoDialog'
import { Dropdown } from 'primereact/dropdown'
import TipoDePagamentoService from '../../app/service/contasAPagar/tipoDePagamentoService';
import HandleErrorService from '../../app/service/handleErrorService';
import CreateTipoDePagamentoDialog from '../../views/contasAPagar/createTipoDePagamentoDialog';
import { Button } from 'primereact/button';
import TooltipButton from '../tooltipButton';
import ConstantsUtil from '../../context/constantsUtil';
import { MultiSelect } from 'primereact/multiselect';
import AuthService from '../../app/service/authService';

const TIPO_DE_PAGAMENTO_PAGE_SIZE = 5
const TIPO_DE_PAGAMENTO_SCROLL_THRESHOLD_PX = 40
// O Dropdown do PrimeReact reseta o texto digitado no filtro sempre que "options" fica com 0 itens.
// Quando a busca realmente não encontra nada, usamos esta option (desabilitada, não selecionável) no lugar
// da lista vazia só para o Dropdown, evitando que ele apague o que o usuário digitou.
const TIPO_DE_PAGAMENTO_NENHUM_RESULTADO_OPTION = { value: '__tipo_de_pagamento_nenhum_resultado__', label: 'Nenhum tipo de pagamento encontrado', disabled: true }

class InputChooseTipoDePagamento extends React.Component {

    constructor(){
        super();
        this.tipoDePagamentoService = new TipoDePagamentoService()
        this.tipoDePagamentoPanelClassName = `tipo-pagamento-panel-simple-view-${Math.random().toString(36).slice(2)}`
        this.tipoDePagamentoOptionsCache = {}
        this.tipoDePagamentoFiltroDebounceTimeout = null
        this.tipoDePagamentoScrollElement = null
    }

    state = {
        chooseTipoDePagamentoDialogVisible: false,
        tiposDePagamentoSelectList: [],
        selectedTipoDePagamentoIdSimpleView: null,
        selectedTipoDePagamentoIdsSimpleViewMultiSelect: null,
        displayCadastroTipoDePagamentoDialog: false,
        filtroTipoDePagamentoSimpleView: '',
        tipoDePagamentoHasMore: true,
        tipoDePagamentoLoadingSimpleView: false,

    }

    componentDidMount(){

        // console.log("this.props.selectedTipoDePagamento: ", this.props.selectedTipoDePagamento)

        // console.log("this.props.simpleView: ", this.props.simpleView)
        if(this.props.simpleView){
            this.simpleSearch()
            this.carregarTipoDePagamentoPreSelecionado()
        }
        else if(this.props.renderDialogOnMount){
            this.setState({chooseTipoDePagamentoDialogVisible: true})
        }
    }

    // selectedTipoDePagamento pode chegar só depois do mount deste componente: em telas de edição (ex:
    // editLancamentoBancarioDialog) o id do tipo de pagamento é setado pelo componente pai de forma assíncrona,
    // via componentDidUpdate, então na hora do nosso componentDidMount a prop ainda está vazia. Por isso
    // reagimos aqui também sempre que o id aparecer/mudar depois do mount.
    componentDidUpdate(prevProps){
        const idAnterior = prevProps.selectedTipoDePagamento && prevProps.selectedTipoDePagamento.id
        const idAtual = this.props.selectedTipoDePagamento && this.props.selectedTipoDePagamento.id
        if(idAtual && idAtual !== idAnterior){
            this.carregarTipoDePagamentoPreSelecionado()
        }
    }

    componentWillUnmount(){
        this.detachTipoDePagamentoScrollListener()
        if(this.tipoDePagamentoFiltroDebounceTimeout){
            clearTimeout(this.tipoDePagamentoFiltroDebounceTimeout)
        }
    }

    carregarTipoDePagamentoPreSelecionado = () => {
        if(!this.props.simpleView || !this.props.selectedTipoDePagamento || !this.props.selectedTipoDePagamento.id){
            return
        }
        this.buscarTipoDePagamentoSelecionadoInicial()
    }

    // searchForSelect não recebe mais o id selecionado (isso fazia o backend ignorar o filtro de texto sempre
    // que havia um tipo de pagamento selecionado). Por isso buscamos esse item separadamente pelo novo endpoint
    // searchForSelectById e o adicionamos manualmente às opções do Dropdown - ver getTiposDePagamentoOptionsSelect.
    buscarTipoDePagamentoSelecionadoInicial = () => {
        this.tipoDePagamentoService.searchForSelectById(this.props.selectedTipoDePagamento.id)
        .then(response => {
            const tipoDePagamentoSelecionado = response.data
            if(!tipoDePagamentoSelecionado){
                return
            }
            this.atualizarTipoDePagamentoOptionsCache([tipoDePagamentoSelecionado])
            if(this.props.multiSelect){
                this.setState({selectedTipoDePagamentoIdsSimpleViewMultiSelect: [tipoDePagamentoSelecionado.value]})
            } else {
                this.setState({selectedTipoDePagamentoIdSimpleView: tipoDePagamentoSelecionado.value})
            }
        })
        .catch(error => {
            // console.log("error 3: ", error)
            HandleErrorService.handleError(error)
        })
    }

    clearSelectedTipoDePagamentoIdSimpleView = () => {
        this.setState({selectedTipoDePagamentoIdSimpleView: null})
    }

    hideTipoDePagamentoDialog = () => {
        this.setState({chooseTipoDePagamentoDialogVisible: false})

        if(this.props.hideDialog){
            this.props.hideDialog()
        }
    }

    handleSelectionTipoDePagamentoChange = async (tipoDePagamento) => {
        const label = tipoDePagamento.nome
        this.props.handleSelectionTipoDePagamentoChange(tipoDePagamento, label)
    }

    handleTipoDePagamentoChangeSelectList = (event) => {
        // console.log("handleTipoDePagamentoChangeSelectList: ", event)
        this.setState({selectedTipoDePagamentoIdSimpleView: event.value})

        if(!event.value){
            this.props.handleSelectionTipoDePagamentoChange('', '')
            return
        }

        let splittedInfo = event.value.split("|@|")
        // console.log("splittedInfo: ", splittedInfo)
        this.handleSelectionTipoDePagamentoChange({id: splittedInfo[0], nome: splittedInfo[1], chaveUnicaTipoDePagamento: splittedInfo[2] !== "null" ? splittedInfo[2] : null})
    }

    handleMultiSelectChange = async (event) => {
        // console.log('handleMultiSelectChange: ', event)
        const name = event.target.name
        const value = event.target.value || []
        await this.setState({ [name]: value })
        let tiposDePagamentoList = value.map(item => ({
            id: item.split("|@|")[0],
            chaveUnicaTipoDePagamento: item.split("|@|")[2] !== "null" ? item.split("|@|")[2] : null
        }));
        this.props.handleSelectionTipoDePagamentoMultiSelectChange(tiposDePagamentoList)
        // console.log('this.state.selectedTipoDePagamentoIdsSimpleViewMultiSelect: ', this.state.selectedTipoDePagamentoIdsSimpleViewMultiSelect)
    }    

    handleKeyPress = async (e) => {
        if (e.key === "Enter") {
            this.inputClick()
          }
    }

    inputClick = () => {
        this.setState({chooseTipoDePagamentoDialogVisible: true})
    }

    generateLabel = () => {
        var label = "Tipo de Pagamento"

        if(this.props.optional){
            label+=" (Opcional)"
        }

        return label
    }

    handleSimpleSearch = (page, filtro) => {
        const idContaBancaria = this.props.filtroContaBancaria && this.props.filtroContaBancaria.idContaBancaria
        const excluiInativos = this.props.filtroContaBancaria && this.props.filtroContaBancaria.excluiInativos
        const somenteDisponiveisOperadorPagamentoDinheiro = AuthService.getPerfil().isOperadorPagamentoDinheiro
        return this.tipoDePagamentoService.searchForSelect(page, TIPO_DE_PAGAMENTO_PAGE_SIZE, filtro, idContaBancaria, excluiInativos, somenteDisponiveisOperadorPagamentoDinheiro)
    }

    atualizarTipoDePagamentoOptionsCache = (itens) => {
        itens.forEach(item => { this.tipoDePagamentoOptionsCache[item.value] = item })
    }

    // (Re)carrega a partir da primeira página. Usado no mount, ao digitar um filtro e após cadastrar um novo tipo de pagamento.
    // Mantemos a lista anterior visível até a resposta chegar (em vez de zerar tiposDePagamentoSelectList aqui): o
    // Dropdown do PrimeReact limpa o texto digitado no filtro sempre que fica sem nenhuma option (options.length === 0),
    // então esvaziar a lista nesse ponto apagava o que o usuário acabou de digitar antes mesmo do resultado chegar.
    simpleSearch = (filtro = '') => {
        this.setState({
            filtroTipoDePagamentoSimpleView: filtro,
            tipoDePagamentoHasMore: true,
            tipoDePagamentoLoadingSimpleView: true,
        })
        this.handleSimpleSearch(0, filtro)
        .then( async response => {
            const dadosCarregados = response.data.content
            this.atualizarTipoDePagamentoOptionsCache(dadosCarregados)
            await this.setState({
                tiposDePagamentoSelectList: dadosCarregados,
                tipoDePagamentoHasMore: dadosCarregados.length === TIPO_DE_PAGAMENTO_PAGE_SIZE,
            })
        })
        .catch(error => {
            // console.log("error 1: ", error)
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            this.setState({tipoDePagamentoLoadingSimpleView: false}, this.carregarMaisTipoDePagamentoEnquantoSemScroll)
        })
    }

    // Chamado quando o usuário scrolla a lista até perto do final: busca a próxima página e concatena.
    carregarProximaPaginaTipoDePagamentoSimpleView = () => {
        if(this.state.tipoDePagamentoLoadingSimpleView || !this.state.tipoDePagamentoHasMore){
            return
        }
        const proximaPagina = Math.ceil(this.state.tiposDePagamentoSelectList.length / TIPO_DE_PAGAMENTO_PAGE_SIZE)
        this.setState({tipoDePagamentoLoadingSimpleView: true})
        this.handleSimpleSearch(proximaPagina, this.state.filtroTipoDePagamentoSimpleView)
        .then(response => {
            const novosItens = response.data.content
            this.atualizarTipoDePagamentoOptionsCache(novosItens)
            this.setState(prevState => ({
                tiposDePagamentoSelectList: [...prevState.tiposDePagamentoSelectList, ...novosItens],
                tipoDePagamentoHasMore: novosItens.length === TIPO_DE_PAGAMENTO_PAGE_SIZE,
            }))
        })
        .catch(error => {
            // console.log("error 2: ", error)
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            this.setState({tipoDePagamentoLoadingSimpleView: false}, this.carregarMaisTipoDePagamentoEnquantoSemScroll)
        })
    }

    // Dropdown/MultiSelect chamam onFilter a cada tecla digitada; aguarda o usuário parar de digitar antes de buscar na API.
    onFilterTipoDePagamentoSimpleView = (event) => {
        if(this.tipoDePagamentoFiltroDebounceTimeout){
            clearTimeout(this.tipoDePagamentoFiltroDebounceTimeout)
        }
        const filtro = event.filter
        this.tipoDePagamentoFiltroDebounceTimeout = setTimeout(() => {
            this.simpleSearch(filtro)
        }, 400)
    }

    attachTipoDePagamentoScrollListener = () => {
        const wrapper = document.querySelector(
            `.${this.tipoDePagamentoPanelClassName} .p-dropdown-items-wrapper, .${this.tipoDePagamentoPanelClassName} .p-multiselect-items-wrapper`
        )
        if(wrapper){
            this.tipoDePagamentoScrollElement = wrapper
            wrapper.addEventListener('scroll', this.handleTipoDePagamentoScroll)
            this.carregarMaisTipoDePagamentoEnquantoSemScroll()
        }
    }

    // O painel do PrimeReact só mostra barra de rolagem quando o conteúdo excede o scrollHeight (200px por padrão).
    // Com apenas TIPO_DE_PAGAMENTO_PAGE_SIZE itens carregados isso nem sempre acontece, e sem scroll o usuário
    // nunca dispara handleTipoDePagamentoScroll para buscar mais páginas. Por isso, enquanto houver mais itens
    // e a lista carregada não preencher/exceder a área visível, buscamos a próxima página automaticamente.
    carregarMaisTipoDePagamentoEnquantoSemScroll = () => {
        const wrapper = this.tipoDePagamentoScrollElement
        if(!wrapper || this.state.tipoDePagamentoLoadingSimpleView || !this.state.tipoDePagamentoHasMore){
            return
        }
        if(wrapper.scrollHeight <= wrapper.clientHeight){
            this.carregarProximaPaginaTipoDePagamentoSimpleView()
        }
    }

    detachTipoDePagamentoScrollListener = () => {
        if(this.tipoDePagamentoScrollElement){
            this.tipoDePagamentoScrollElement.removeEventListener('scroll', this.handleTipoDePagamentoScroll)
            this.tipoDePagamentoScrollElement = null
        }
    }

    handleTipoDePagamentoScroll = (event) => {
        const wrapper = event.target
        const chegouPertoDoFim = wrapper.scrollTop + wrapper.clientHeight >= wrapper.scrollHeight - TIPO_DE_PAGAMENTO_SCROLL_THRESHOLD_PX
        if(chegouPertoDoFim){
            this.carregarProximaPaginaTipoDePagamentoSimpleView()
        }
    }

    // 1) Como searchForSelect não força mais o item selecionado a aparecer na página/filtro atual, garantimos
    //    aqui que ele continue nas opções (buscado à parte por buscarTipoDePagamentoSelecionadoInicial e guardado
    //    em tipoDePagamentoOptionsCache) - senão o Dropdown não acha o label do value selecionado e fica em branco.
    // 2) Ver comentário de TIPO_DE_PAGAMENTO_NENHUM_RESULTADO_OPTION. Precisa valer para QUALQUER render em que a
    //    lista esteja vazia (inclusive o instante entre o setState que zera a lista e o setState que desliga o
    //    loading, logo após uma busca sem resultado) - senão o Dropdown chega a ver options.length === 0 e limpa
    //    o filtro digitado. Como o painel só fica visível quando o usuário abre o Dropdown, o placeholder não
    //    chega a aparecer durante o carregamento inicial (painel fechado).
    getTiposDePagamentoOptionsSelect = () => {
        const lista = this.state.tiposDePagamentoSelectList
        const valorSelecionado = this.state.selectedTipoDePagamentoIdSimpleView
        const selecionadoAusente = valorSelecionado
            && !lista.some(item => item.value === valorSelecionado)
            && this.tipoDePagamentoOptionsCache[valorSelecionado]
        const listaComSelecionado = selecionadoAusente ? [...lista, selecionadoAusente] : lista
        if(listaComSelecionado.length === 0){
            return [TIPO_DE_PAGAMENTO_NENHUM_RESULTADO_OPTION]
        }
        return listaComSelecionado
    }

    // Garante que itens já selecionados no MultiSelect continuem aparecendo como chip mesmo que tenham saído
    // da página/filtro atualmente carregado (senão o PrimeReact não acha o label e o chip fica em branco).
    getTiposDePagamentoOptionsMultiSelect = () => {
        const lista = this.state.tiposDePagamentoSelectList
        const valoresJaNaLista = new Set(lista.map(item => item.value))
        const selecionadosAusentes = (this.state.selectedTipoDePagamentoIdsSimpleViewMultiSelect || [])
            .filter(valor => !valoresJaNaLista.has(valor) && this.tipoDePagamentoOptionsCache[valor])
            .map(valor => this.tipoDePagamentoOptionsCache[valor])
        return [...lista, ...selecionadosAusentes]
    }

    hideCadastroTipoDePagamentoDialog = () => {
        this.setState({displayCadastroTipoDePagamentoDialog: false})
    }

    handleNewFornecedorCadastrado = () => {
        this.hideCadastroTipoDePagamentoDialog()
        this.simpleSearch()
    }


    render(){

        const handleView = () => {
            if(this.props.simpleView){
                return(
                <div className='col-md-12'>

                    <div className='row'>
                        <label style={{ display: 'block' }}>Tipo de Pagamento</label>
                        {renderCadastrarButtonSimpleView()}
                    </div>

                    {handleSelectView()}

                    {renderCreateTipoDePagamentoDialogSimpleView()}

                </div>
                )
            }

            return(
                <>
                    {renderInput()}
                </>
            )

        }

        const handleSelectView = () => {
                if(this.props.multiSelect){
                    return(
                        <>
                            {renderMultiSelect()}
                        </>
                    )
                }
                return (
                    <>
                        {renderSelect()}
                    </>
                )
        }

        const renderMultiSelect = () => {
            return(
                <>
                    <div className='row'>
                        <MultiSelect
                            style={{width: '100%'}}
                            display="chip"
                            showClear
                            value={this.state.selectedTipoDePagamentoIdsSimpleViewMultiSelect}
                            options={this.getTiposDePagamentoOptionsMultiSelect()}
                            name="selectedTipoDePagamentoIdsSimpleViewMultiSelect"
                            onChange={this.handleMultiSelectChange}
                            optionLabel="label"
                            placeholder='Selecione'
                            filter
                            filterBy="label"
                            panelClassName={this.tipoDePagamentoPanelClassName}
                            onFilter={this.onFilterTipoDePagamentoSimpleView}
                            onShow={this.attachTipoDePagamentoScrollListener}
                            onHide={this.detachTipoDePagamentoScrollListener}
                        />
                    </div>
                </>
            )
        }

        const renderSelect = () => {
            return (
                <>

                    <div className='row'>
                        <Dropdown
                            className={this.props.error ? ConstantsUtil.primereactInputErrorClass : ""}
                            value={this.state.selectedTipoDePagamentoIdSimpleView}
                            // value={this.props.selectedTipoDePagamentoLabel}
                            options={this.getTiposDePagamentoOptionsSelect()}
                            onChange={this.handleTipoDePagamentoChangeSelectList}
                            optionLabel="label"
                            filter
                            showClear
                            style={{width: '100%'}}
                            filterBy="label"
                            placeholder="Selecione"
                            emptyMessage=""
                            emptyFilterMessage=""
                            panelClassName={this.tipoDePagamentoPanelClassName}
                            onFilter={this.onFilterTipoDePagamentoSimpleView}
                            onShow={this.attachTipoDePagamentoScrollListener}
                            onHide={this.detachTipoDePagamentoScrollListener}
                        />
                        <small className="p-error">{this.props.error ? "Selecione o Tipo de Pagamento" : ""}</small>
                    </div>

                </>


            )
        }

        const renderInput = () => {
            return (
                <>
                    <label htmlFor="tipoDePagamento">{this.generateLabel()}</label>
                    <input
                        type="text"
                        className={"form-control " + this.props.inputTipoDePagamentoErrorClass}
                        readOnly
                        value = {this.props.selectedTipoDePagamentoLabel}
                        name="selectedTipoDePagamentoLabel"
                        id="selectedTipoDeRecebimentoLabel"
                        onClick={this.inputClick}
                        onKeyPress={this.handleKeyPress}
                        placeholder="Nenhum Tipo de Pagamento Selecionado..."
                        disabled={this.props.disabled}
                    />
                    <div className="invalid-feedback">Selecione o Tipo de Pagamento</div> 
                </>
            )
        }

        const renderHTMLFormat = () => {
            if(this.props.noHTMLFormat){
                return (
                    <>
                    {handleView()}
                    </>
                )
            }
            else {
                return (
                    <>
                    <div className="col-md-4">
                        {handleView()}
                    </div>
                    </>
                )
            }
        }

        const renderCadastrarButtonSimpleView = () => {
            if(this.props.simpleView && this.props.enableCadastrarButtonInSimpleView){
                return (
                    <>
                        <TooltipButton
                            tooltip="Cadastrar Tipo de Pagamento"
                            style={{marginLeft: '15px', maxWidth: '20px', maxHeight: '20px'}}
                            icon="pi pi-plus"
                            onClick = {() => this.setState({displayCadastroTipoDePagamentoDialog: true})}
                        />
                    </>
                )
            }
        }

        const renderCreateTipoDePagamentoDialogSimpleView = () => {
            return(
            <>
                <CreateTipoDePagamentoDialog
                    visible={this.state.displayCadastroTipoDePagamentoDialog}
                    search={this.simpleSearch}
                    hideDialog={this.hideCadastroTipoDePagamentoDialog}
                    handleNewFornecedorCadastrado={this.handleNewFornecedorCadastrado}
                />            
            </>
            )
        }

        const renderChooseTipoDePagamentoDialog = () => {
            if(!this.props.simpleView)
            return(
                <ChooseTipoDePagamentoDialog
                    visible={this.state.chooseTipoDePagamentoDialogVisible || this.props.forceShowDialog}
                    header={this.generateLabel()}
                    list={this.props.tipoDePagamentoList}
                    contaBancariaId={this.props.contaBancariaId}
                    search={this.props.search}
                    forceUpdate={this.props.forceUpdate}
                    doneForceUpdate={this.props.doneForceUpdate}
                    hideDialog={this.hideTipoDePagamentoDialog}
                    handleSelectionTipoDePagamentoChange={this.handleSelectionTipoDePagamentoChange}
                    provisoesAPagar={this.props.provisoesAPagar}
                    fichaDePagamento={this.props.fichaDePagamento}
                    onFinishSearchTipoDePagamentoList={this.props.onFinishSearchTipoDePagamentoList}
                />
            )
        }

        return(
            <>
                {renderHTMLFormat()}

                {renderChooseTipoDePagamentoDialog()}


            </>
        )

    }

}

export default InputChooseTipoDePagamento
